import {Singleton} from 'annotation';
import environment from 'environment';

import ProxyService from './Proxy';
import EntityAware from '../entity/EntityAware';
import Parameter from "./Parameter";
import Response from "./Response";
import AsesmenPendaftar from "../entity/AsesmenPendaftar";
import Authentication from "../Authentication";
import Notification from '../Notification'
import BankSoal from "../entity/BankSoal";

@Singleton
export default class BankSoalService extends ProxyService {

    public api: string = environment.BANK_SOAL_API;   // define api url to fetch data

    public serializer: EntityAware = BankSoal;

    public serializerAsesmen: EntityAware = AsesmenPendaftar;

    public findSoals(pendidikan: string): Promise<any> {
        const parameter = new Parameter().setUrl(this.api + `/soal?pendidikan=${pendidikan}`);
        return this.request(parameter);
    }

    public async doValidate(nomor: string): Promise<any> {
        const parameter = new Parameter()
            .setMethod(Parameter.methods.GET)
            .setEnableNotif(false)
            .setUrl(this.api + `/verification?nomor=${nomor}`)
            .serializeData(this.serializerAsesmen);

        return this.request(parameter).then((response: Response) => {
            if (response.statusResponse) {
                let data: any = response.getData({});
                Authentication.setAsesmen(data)

                Notification.showNotification({text: "Nomor pendaftar berhasil di validasi", type: 'info'});
            } else {
                Notification.showNotification({text: 'Nomor pendaftar tidak ditemukan atau tidak valid, Silahkan hubungi admin DimasKHAS'}, true);
            }
        });
    }

    public doSendJawaban(param: any): Promise<any> {
        const api: string = this.api + `/jawaban`;
        return this.request(new Parameter(param).setMethod(Parameter.methods.POST).setUrl(api));
    }

    public downloadJawaban(pendidikan: any, tahun: any) {
        return super.downloadFile(this.api + `/jawaban/download?pendidikan=${pendidikan}&tahun=${tahun}`, "Rekap Jawaban Asesmen.xlsx", false);
    }

}
